<template>
  <div class="search-input">
    <slot v-if="isMobile">
      <input @keyup.enter="searchBtn($event)" :value="searchValue" type="text" class="search" placeholder="Oyun Arayın"/>
    </slot>
    <slot v-else>
      <input @input="searchBtn($event)" :value="searchValue" type="text" class="search" style="height: 30px" placeholder="Oyun Arayın"/>
    </slot>
  </div>
</template>

<script>
  export default{
      data(){
        return{
          toggle:false,
        }
      },
      computed:{
        searchValue(){
          return this.$store.getters['slot/getSearch'];
        }
      },
      methods:{
        searchBtn(event){
          if(event.target.value.length > 2){
            return this.$store.dispatch('slot/search', event.target.value);
          }else{
            return this.$store.dispatch('slot/search', null);
          }
        }
      }
  }
</script>